(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function formatMoney(cents) {
    const fmt = window.theme.money || '{{amount}}';
    const v = (cents / 100);
    const two = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const comma = v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) =>
      k === 'amount_no_decimals' ? Math.round(v).toLocaleString('en') :
      k === 'amount_with_comma_separator' ? comma : two);
  }

  /* Mobile nav + search */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-action]');
    if (!t) return;
    const a = t.dataset.action;
    if (a === 'menu-open') { $('#mobile-nav').classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    if (a === 'menu-close') { $('#mobile-nav').classList.remove('is-open'); document.body.style.overflow = ''; }
    if (a === 'search') { const s = $('#search-bar'); s.classList.toggle('is-open'); if (s.classList.contains('is-open')) $('input', s).focus(); }
    if (a === 'cart-open') { e.preventDefault(); openDrawer(); }
    if (a === 'cart-close') closeDrawer();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); $('#mobile-nav')?.classList.remove('is-open'); document.body.style.overflow = ''; } });

  /* Cart drawer */
  async function refreshDrawer() {
    const res = await fetch(window.theme.routes.cart + '?section_id=cart-drawer-content');
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#drawer-inner');
    if (fresh) $('#drawer-inner').innerHTML = fresh.innerHTML;
    const cart = await (await fetch(window.theme.routes.cart + '.js')).json();
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
  }
  function openDrawer() {
    if (!$('#cart-drawer')) { location.href = window.theme.routes.cart; return; }
    document.body.classList.add('drawer-open');
    refreshDrawer();
  }
  function closeDrawer() { document.body.classList.remove('drawer-open'); }

  async function changeLine(key, quantity) {
    const box = $('#drawer-inner') || document.body;
    box.classList.add('is-loading');
    await fetch(window.theme.routes.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    if (document.body.classList.contains('template-cart')) { location.reload(); return; }
    await refreshDrawer();
    box.classList.remove('is-loading');
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    changeLine(b.dataset.key, parseInt(b.dataset.lineChange, 10));
  });

  /* Add to cart (forms with data-ajax-cart) */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const btn = $('[type=submit]', form);
    const label = btn.innerHTML;
    btn.disabled = true; btn.textContent = btn.dataset.adding || 'Adding…';
    const err = $('[data-error]', form);
    if (err) err.hidden = true;
    try {
      const res = await fetch(window.theme.routes.cart_add + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      openDrawer();
    } catch (ex) {
      if (err) { err.textContent = ex.message; err.hidden = false; } else alert(ex.message);
    } finally { btn.disabled = false; btn.innerHTML = label; }
  });

  /* Product variant picker */
  $$('[data-product-form]').forEach((root) => {
    const variants = JSON.parse($('[data-variants]', root).textContent);
    const idInput = $('input[name=id]', root);
    const priceEl = $('[data-price]', root);
    const stockEl = $('[data-stock]', root);
    const btn = $('[data-add-btn]', root);
    const gallery = $('[data-gallery]');
    function update() {
      const selected = $$('fieldset.option', root).map((fs) => $('input:checked', fs)?.value);
      const v = variants.find((x) => x.options.every((o, i) => o === selected[i]));
      // mark unavailable combos
      $$('fieldset.option', root).forEach((fs, idx) => {
        $$('input', fs).forEach((inp) => {
          const test = selected.slice(); test[idx] = inp.value;
          const m = variants.find((x) => x.options.every((o, i) => o === test[i]));
          inp.classList.toggle('unavailable', !m || !m.available);
        });
      });
      if (!v) { btn.disabled = true; btn.textContent = btn.dataset.unavailable; return; }
      idInput.value = v.id;
      priceEl.innerHTML = v.compare_at_price > v.price
        ? `<s>${formatMoney(v.compare_at_price)}</s><span class="sale">${formatMoney(v.price)}</span>`
        : `<span>${formatMoney(v.price)}</span>`;
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.dataset.add : btn.dataset.soldout;
      if (stockEl) { stockEl.classList.toggle('out', !v.available); stockEl.textContent = v.available ? stockEl.dataset.in : stockEl.dataset.out; }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      if (v.featured_media && gallery) {
        const target = gallery.querySelector(`[data-media-id="${v.featured_media.id}"]`);
        if (target) gallery.prepend(target);
      }
    }
    root.addEventListener('change', (e) => { if (e.target.closest('fieldset.option')) update(); });
    update();
  });

  /* Quantity steppers */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10));
  });

  /* Collection sort */
  $$('[data-sort]').forEach((sel) => sel.addEventListener('change', () => {
    const url = new URL(location.href); url.searchParams.set('sort_by', sel.value); location.href = url;
  }));

  /* Reveal */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { threshold: .12 });
    $$('.reveal').forEach((el) => io.observe(el));
  } else $$('.reveal').forEach((el) => el.classList.add('in'));
})();
